type Props = {
  src: string
  alt?: string
  className?: string
  /** Autoplay+loop (for detail views). Off for list thumbnails to avoid many concurrent videos. */
  autoPlay?: boolean
}

// Renders a looping muted <video> for .mp4 sources, otherwise an <img>.
// Keeps backward compatibility with existing gif/image URLs.
export default function ExerciseMedia({ src, alt, className, autoPlay = true }: Props) {
  const isVideo = /\.mp4(\?|$)/i.test(src)

  if (isVideo) {
    return (
      <video
        // #t=0.1 forces a still frame to render when not autoplaying (poster-like).
        src={autoPlay ? src : `${src}#t=0.1`}
        className={className}
        autoPlay={autoPlay}
        loop={autoPlay}
        muted
        playsInline
        preload="metadata"
      />
    )
  }

  return <img src={src} alt={alt} className={className} />
}
